import styled, { css } from "styled-components";

const Tag = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;

  width: min-content;
  padding: 0.5rem 1rem;
  background-color: #d97706;
  z-index: 10;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 2px;
  color: #ffffff;
  height: min-content;
  font-size: 0.6rem;

  ${({ position }) => {
    switch (position) {
      case "top-center":
        return css`
          top: 0%;
          left: 50%;
          transform: rotate(0) translate(-50%, -50%);
        `;
      case "bottom-left":
        return css`
          bottom: -10%;
          left: 100%;
          transform: rotate(30deg) translate(-50%, 100%);
        `;
      default:
        return css`
          top: -10%;
          left: 100%;
          transform: rotate(30deg) translate(-50%, 100%);
        `;
    }
  }}
`;

export default function PremiumTag({ position }) {
  return <Tag position={position}>PREMIUM</Tag>;
}
